import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    settings: {
      containerWidth: 1200,
      totalGrids: 12,
      gutterSpace: 20,
    },
    rows: [{
      columns: [{
        grids: 12,
        rows: [{
          columns: [{
            grids: 8,
          }, {
            grids: 4,
          }],
        }],
      }],
    }],
  },
  getters: {
    cw: (state) => (+state.settings.containerWidth),
    gutterSpace: (state) => (+state.settings.gutterSpace),
    gutterUnitSpace: (state, getters) => (getters.gutterSpace / 2),
    totalGutterSpace: (state, getters) => (getters.gutterSpace * (getters.totalGrids - 1)),
    totalGridSpace: (state, getters) => (getters.cw - getters.totalGutterSpace),
    totalGrids: (state) => (+state.settings.totalGrids),
    gridSize: (state, getters) => 100 / getters.totalGrids,
    grids: (state, getters) => {
      let index = 0;
      const grids = [];
      while (index < getters.totalGrids) {
        grids.push(index);
        index += 1;
      }
      return grids;
    },
    details: (state, getters) => ({
      cw: getters.cw,
      gutterSpace: getters.gutterSpace,
      gutterUnitSpace: getters.gutterUnitSpace,
      totalGutterSpace: getters.totalGutterSpace,
      totalGridSpace: getters.totalGridSpace,
      totalGrids: getters.totalGrids,
      gridSize: getters.gridSize,
    }),
  },
  mutations: {
    updateSettings(state, payload) {
      state.settings = {
        ...payload,
      };
      const totalGrids = +state.settings.totalGrids;
      const rightGrids = Math.floor(totalGrids / 3);
      const leftGrids = totalGrids - rightGrids;
      state.rows = [{
        columns: [{
          grids: totalGrids,
          rows: [{
            columns: [{
              grids: leftGrids,
            }, {
              grids: rightGrids,
            }],
          }],
        }],
      }];
    },
  },
  actions: {
  },
  modules: {
  },
});
